// extracted by mini-css-extract-plugin
export var bodySections = "_aj-8";
export var gray = "_aj-7";
export var green = "_aj-4";
export var iconContainer = "_aj-9";
export var iconWidgetContainer = "_aj-1";
export var phoneIcon = "_aj-2";
export var red = "_aj-5";
export var statusDot = "_aj-3";
export var widgetContainer = "_aj-0";
export var yellow = "_aj-6";